/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../SharedComponents/DeleteDialog.scss";
import { Button } from "@forge/common";
export interface SuccessDialogProps {
  handleClose(): void;
  SuccessConfirmationMessage?: string;
  successMessage?: React.ReactNode;
  open: boolean;
  title: string | React.ReactNode;
}

const SuccessDialog = (props: SuccessDialogProps) => {
  if (!props) {
    return null;
  }
  return (
    <Dialog open={props.open}>
      <DialogTitle className="dialogHeading" id="dialog-title">
        {props.title}
        <IconButton
          edge="end"
          color="inherit"
          onClick={props.handleClose} //coverity issue fix - Corrected: Added function call parentheses
          aria-label="close"
          sx={{ marginLeft: "auto" }}
        >
          <CloseIcon onClick={props.handleClose} />
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="dialogInfo">
          {props?.SuccessConfirmationMessage}

          {props?.successMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          paddingRight: 4,
          paddingBottom: 4,
        }}
      >
        <Button variant="primary" onClick={props?.handleClose}>
          Ok{" "}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
/// end return Dialog

export default SuccessDialog;
